export default "__VITE_ASSET__7SrYD2j___"